import react, { useEffect, useState } from "react";
import axios from 'axios';
import Spinner from "./Spinner";
import useHook from "../hooks/useHook"

const Random = () => {
    
    
    const {loading, gif, fetchApi} = useHook();
  
    return (
        
        <div className='w-1/2  bg-green-500 rounded-lg border border-black
    flex flex-col items-center gap-y-5 mt-[15px]'>
            <h1 className='mt-[15px] text-2xl underline uppercase font-bold'> A Random Gif</h1>
       {
        loading ? (<Spinner/>) : (<img src= {gif} width="450" />)
       }
            
            <button className="w-10/12 bg-yellow-500 text-lg py-2 rounded-lg mb-[20px]" onClick={fetchApi}>

                Generate

            </button>
        </div>
    );
}
export default Random;